import { getMarketInvestibles, refreshInvestibles } from '../../contexts/InvestibesContext/investiblesContextHelper';
import { getComment, getMarketComments } from '../../contexts/CommentsContext/commentsContextHelper';
import { getMarketPresences } from '../../contexts/MarketPresencesContext/marketPresencesHelper';
import {
  getInCurrentVotingStage, getProposedOptionsStage
} from '../../contexts/MarketStagesContext/marketStagesContextHelper';
import _ from 'lodash';
import { Typography } from '@material-ui/core';
import GravatarGroup from '../Avatars/GravatarGroup';
import { GmailTabItem, GmailTabs } from '../../containers/Tab/Inbox';
import { Block } from '@material-ui/icons';
import OptionVoting from '../../pages/Dialog/Decision/OptionVoting';
import React, { useContext, useEffect } from 'react';
import { InvestiblesContext } from '../../contexts/InvestibesContext/InvestiblesContext';
import { MarketStagesContext } from '../../contexts/MarketStagesContext/MarketStagesContext';
import { CommentsContext } from '../../contexts/CommentsContext/CommentsContext';
import { MarketPresencesContext } from '../../contexts/MarketPresencesContext/MarketPresencesContext';
import { useIntl } from 'react-intl';
import { findMessagesForCommentIds } from '../../utils/messageUtils';
import ThumbsUpDownIcon from '@material-ui/icons/ThumbsUpDown';
import { getMarketInfo } from '../../utils/userFunctions';
import { moveInvestibleToCurrentVoting } from '../../api/investibles';
import { OperationInProgressContext } from '../../contexts/OperationInProgressContext/OperationInProgressContext';
import { ACTIVE_STAGE } from '../../constants/markets';
import { useLocation } from 'react-router';
import { useOpenChipNotification } from '../../utils/openChipNotification';
import { NotificationsContext } from '../../contexts/NotificationsContext/NotificationsContext';
import { getPageReducerPage, usePageStateReducer } from '../PageState/pageStateHooks';
import { getNewMessages, isNew, optionsInDisplayOrder } from '../../utils/optionOrder';

export { getNewMessages, isNew } from '../../utils/optionOrder';

export function getNewBugNotifications(comment, messagesState, replies = []) {
  // A bug's notification can be keyed on a reply's own id, so check the whole thread (root + replies)
  // when replies are supplied - this is what bolds a row that has a notification anywhere in its thread,
  // including resolved bugs whose root notification cleared but a reply's did not (C-all-1047).
  const threadIds = [comment.id, ...replies.map((reply) => reply.id)];
  const myMessages = findMessagesForCommentIds(threadIds, messagesState.messages) || [];
  return myMessages.filter((myMessage) => {
    if (myMessage?.highlighted_list !== undefined) {
      return !_.isEmpty(_.intersection(myMessage.highlighted_list, threadIds));
    }
    return myMessage?.is_highlighted;
  });
}

function Options(props) {
  const { anInlineMarket, marketId, investibleId, inArchives, isEditable, isSent, groupId, removeActions,
    selectedInvestibleIdParent, searchResults, isInbox, useCompression, parentCommentResolved } = props;
  const location = useLocation();
  const { hash } = location;
  const intl = useIntl();
  const [investiblesState, invDispatch] = useContext(InvestiblesContext);
  const [marketStagesState] = useContext(MarketStagesContext);
  const [commentsState] = useContext(CommentsContext);
  const [marketPresencesState] = useContext(MarketPresencesContext);
  const [messagesState] = useContext(NotificationsContext);
  const openChipNotification = useOpenChipNotification();
  const [, setOperationRunning] = useContext(OperationInProgressContext);
  const [pageStateFull, pageDispatch] = usePageStateReducer('options');
  const underConsiderationStage = getInCurrentVotingStage(marketStagesState, anInlineMarket.id);
  const inlineInvestibles = getMarketInvestibles(investiblesState, anInlineMarket.id, searchResults, isInbox)
    || [];
  const anInlineMarketPresences = getMarketPresences(marketPresencesState, anInlineMarket.id) || [];
  function getInlineInvestiblesForStage(stage) {
    return optionsInDisplayOrder(inlineInvestibles, stage, anInlineMarket.id,
      anInlineMarketPresences, messagesState);
  }
  const underConsideration = getInlineInvestiblesForStage(underConsiderationStage);
  const firstConsidered = _.isEmpty(underConsideration) ? undefined : underConsideration[0];
  const selectedInvestibleId = selectedInvestibleIdParent ||
    (useCompression ? undefined : firstConsidered?.investible?.id);
  const selectedInvestible = inlineInvestibles.find((inv) => inv.investible.id === selectedInvestibleId);
  const proposedStage = getProposedOptionsStage(marketStagesState, anInlineMarket.id);
  const selectedStageTab = selectedInvestible ?
    (getMarketInfo(selectedInvestible, anInlineMarket.id).stage === proposedStage.id ? 1 : 0) : undefined;
  const [pageState, updatePageState] = getPageReducerPage(pageStateFull, pageDispatch, anInlineMarket.id,
    {tabIndex: 0, selectedInvestibleIdTabZero: selectedStageTab === 0 ? selectedInvestibleId : undefined,
      selectedInvestibleIdTabOne: selectedStageTab === 1 ? selectedInvestibleId : undefined,
      investibleIdTabZeroWasSet: false, investibleIdTabOneWasSet: false});
  const anInlineMarketInvestibleComments = getMarketComments(commentsState, anInlineMarket.id) || [];
  const abstaining = anInlineMarketPresences.filter((presence) => presence.abstain);
  const { tabIndex, selectedInvestibleIdTabZero, selectedInvestibleIdTabOne, investibleIdTabZeroWasSet,
    investibleIdTabOneWasSet } = pageState;
  const useTabIndex = selectedStageTab || tabIndex;
  const target = location.state?.notification || location.state?.searchMatch;
  const notifiedRoot = target?.marketId === anInlineMarket.id
    ? getComment(commentsState, anInlineMarket.id, target.commentId) : undefined;
  const foundInv = inlineInvestibles.find((inv) => hash?.includes(inv.investible.id) ||
    (hash && inv.investible.id === notifiedRoot?.investible_id));

  function setUseSelectedInvestibleIdTabZero(id) {
    updatePageState({ selectedInvestibleIdTabZero: id, investibleIdTabZeroWasSet: true });
  }

  function setUseSelectedInvestibleIdTabOne(id) {
    updatePageState({ selectedInvestibleIdTabOne: id, investibleIdTabOneWasSet: true });
  }

  useEffect(() => {
    if (hash && foundInv) {
      const foundStageTab = foundInv ?
        (getMarketInfo(foundInv, anInlineMarket?.id)?.stage === proposedStage?.id ? 1 : 0) : undefined;
      // Only set once to avoid spinning
      if (foundStageTab === 0 && foundInv.investible.id !== selectedInvestibleIdTabZero) {
        updatePageState({ selectedInvestibleIdTabZero: foundInv.investible.id, investibleIdTabZeroWasSet: true });
      } 
      if (foundStageTab === 1 && foundInv.investible.id !== selectedInvestibleIdTabOne) {
        updatePageState({ selectedInvestibleIdTabOne: foundInv.investible.id, investibleIdTabOneWasSet: true });
      }
      if (tabIndex !== foundStageTab) {
        updatePageState({ tabIndex: foundStageTab });
      }
    }
  }, [hash, selectedInvestibleId, anInlineMarket?.id, proposedStage?.id, foundInv, foundInv?.investible?.id, updatePageState, selectedInvestibleIdTabZero, 
    selectedInvestibleIdTabOne, tabIndex]);

  const abstained = _.isEmpty(abstaining) ? undefined :
    <div style={{display: 'flex', paddingLeft: '2rem', alignItems: 'center'}}>
      <Typography variant='body2' style={{paddingRight: '0.5rem'}}>
        {intl.formatMessage({ id: 'commentAbstainingLabel' })}</Typography>
      <GravatarGroup users={abstaining}/>
    </div>;

  function onDrop(event, fromStage, toStage) {
    const moveInfo = {
      marketId: anInlineMarket.id,
      investibleId: event.dataTransfer.getData('text'),
      stageInfo: {
        current_stage_id: fromStage.id,
        stage_id: toStage.id,
      },
    };
    setOperationRunning(true);
    return moveInvestibleToCurrentVoting(moveInfo)
      .then((inv) => {
        refreshInvestibles(invDispatch, () => {}, [inv]);
        setOperationRunning(false);
      });
  }

  function onDropApprovable(event) {
    if (isEditable) {
      return onDrop(event, proposedStage, underConsiderationStage);
    }
  }

  function onDropProposed(event) {
    if (isEditable) {
      return onDrop(event, underConsiderationStage, proposedStage);
    }
  }

  if (_.isEmpty(inlineInvestibles)) {
    return React.Fragment;
  }

  function getSelectedInvestibleId() {
    if (useTabIndex === 0 && !investibleIdTabZeroWasSet) {
      return selectedInvestibleId;
    }
    if (useTabIndex === 1 && !investibleIdTabOneWasSet) {
      return selectedInvestibleId;
    }
    return useTabIndex === 0 ? selectedInvestibleIdTabZero : selectedInvestibleIdTabOne;
  }

  const proposed = getInlineInvestiblesForStage(proposedStage);
  // B-all-471: isNew was called without messagesState here, so the red "new" tag on the
  // Approvable Options tab could never show even when a row was bolded as new.
  const votingNewMessages = underConsideration.flatMap((inv) => getNewMessages(inv, messagesState));
  const unreadCount = _.size(underConsideration.filter((inv) => isNew(inv, messagesState)));
  // B-all-480: proposed options can have notifications too, so that tab gets a new message count
  const proposedNewMessages = proposed.flatMap((inv) => getNewMessages(inv, messagesState));
  const unreadProposedCount = _.size(proposed.filter((inv) => isNew(inv, messagesState)));
  const htmlColor = _.isEmpty(underConsideration) ? '#8f8f8f' : (unreadCount > 0 ? '#E85757' : '#2D9CDB');
  const tabInvestibles = useTabIndex === 0 ? underConsideration : proposed;
  return (
    <div style={{marginTop: '1rem'}}>
      {abstained}
      <div onDrop={useTabIndex === 0 ? onDropProposed : onDropApprovable}
           onDragOver={(event)=>event.preventDefault()}>
        <GmailTabs
          value={useTabIndex}
          onChange={(event, value) => {
            updatePageState({ tabIndex: value });
          }}
          indicatorColors={[htmlColor, '#2F80ED']}
          style={{ paddingBottom: '1rem' }}>
          {/* B-all-480: no content counts on option tabs - options are not worked down, so only
             the new message count displays */}
          <GmailTabItem icon={<ThumbsUpDownIcon htmlColor={htmlColor} />} onDrop={onDropApprovable}
                        onTagClick={unreadCount > 0 ? () => openChipNotification(votingNewMessages) : undefined}
                        label={intl.formatMessage({id: 'decisionDialogCurrentVotingLabel'})}
                        color='black' tagLabel={unreadCount > 0 ? intl.formatMessage({id: 'new'}) : undefined}
                        tagColor={unreadCount > 0 ? '#E85757' : undefined} toolTipId='votedOptionsToolTip'
                        tag={unreadCount > 0 ? `${unreadCount}` : undefined} />
          <GmailTabItem icon={<Block />} onDrop={onDropProposed} toolTipId='proposedOptionsToolTip'
                        onTagClick={unreadProposedCount > 0 ? () => openChipNotification(proposedNewMessages) : undefined}
                        label={intl.formatMessage({id: 'decisionDialogProposedOptionsLabel'})}
                        tagLabel={unreadProposedCount > 0 ? intl.formatMessage({id: 'new'}) : undefined}
                        tagColor={unreadProposedCount > 0 ? '#E85757' : undefined}
                        tag={unreadProposedCount > 0 ? `${unreadProposedCount}` : undefined} />
        </GmailTabs>
      </div>
      {_.isEmpty(tabInvestibles) && useTabIndex === 0 && (
        <Typography style={{marginTop: '2rem', maxWidth: '40rem', marginLeft: 'auto', marginRight: 'auto'}}
                    variant="body1">
          {intl.formatMessage({id: 'decisionDialogCurrentVotingLabel'})} is empty.<br/><br/>
          Options to approve display here.
        </Typography>
      )}
      {_.isEmpty(tabInvestibles) && useTabIndex === 1 && (
        <Typography style={{marginTop: '2rem', maxWidth: '40rem', marginLeft: 'auto', marginRight: 'auto'}}
                    variant="body1">
          {intl.formatMessage({id: 'decisionDialogProposedOptionsLabel'})} is empty.<br/><br/>
          Options that are rejected or not ready for voting display here.
        </Typography>
      )}
      <OptionVoting
        marketPresences={anInlineMarketPresences}
        investibles={tabInvestibles}
        marketId={anInlineMarket.id}
        parentMarketId={marketId}
        parentInvestibleId={investibleId}
        groupId={groupId}
        comments={anInlineMarketInvestibleComments}
        inArchives={inArchives}
        // B-all-651: the comment's own resolved flag is written synchronously, while the
        // inline market is deactivated later off the event stream, so keying only on the
        // stage leaves an option's actions live for the whole interval between the two.
        // A standalone decision market has no parent question, hence both sources.
        questionResolved={!!parentCommentResolved || anInlineMarket.market_stage !== ACTIVE_STAGE}
        isAdmin={isEditable}
        isSent={isSent}
        isInbox={isInbox}
        isInVoting={useTabIndex === 0}
        removeActions={removeActions}
        selectedInvestibleId={getSelectedInvestibleId()}
        setSelectedInvestibleId={useTabIndex === 0 ? setUseSelectedInvestibleIdTabZero :
          setUseSelectedInvestibleIdTabOne}
      />
    </div>
  );
}

export default Options;
